module.exports = __webpack_public_path__ + "static/media/email.aade2b25.svg";